export default __webpack_public_path__ + "static/media/icon_search_main.3db30a66.svg";